import React from 'react';
import { useBreakpoint } from '../../hooks/useBreakpoint.js';

var BreakPointItem = function (_a) {
    var children = _a.children, min = _a.min, max = _a.max, _b = _a.includeMin, includeMin = _b === void 0 ? false : _b, _c = _a.includeMax, includeMax = _c === void 0 ? false : _c, _d = _a.visibleOnInit, visibleOnInit = _d === void 0 ? true : _d;
    var show = useBreakpoint({ min: min, max: max, includeMin: includeMin, includeMax: includeMax, visibleOnInit: visibleOnInit });
    return show ? React.createElement(React.Fragment, null, children) : null;
};

export { BreakPointItem };
//# sourceMappingURL=index.js.map
